/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { IToastOpcoes, Toast } from "../../../Components/Toast/Toast";
import { IContratosLista, IListaContratosDTO } from "../../../Dtos/Comercial/Contratos/ContratosDtos";
import ApiService from "../../../Config/ApiConfig";
import { ActionButton, Card, CardActions, CardField, CardView } from "../../../Components/CardView/CardView";
import { format } from "date-fns";
import { credencialTemAcesso } from "../../../Components/Layout/MenuData";
import { Edit } from "lucide-react";
import { Table, TableContainer, Td, Th } from "../../../Components/Table/Table";
import AppLayout from "../../../Components/Layout/Layout";
import LoadingPage from "../../../Components/Loading/Loading";
import { TopActions } from "../../../Components/TopActions/TopActions";
import Pagination from "../../../Components/Pagination/Pagination";
import dayjs from "dayjs"

export const ListaContratosPage = () => {
    const navigate = useNavigate()
    const [sd48s, setSd48s] = useState<IContratosLista[]>([])
    const [filter, setFilter] = useState('');
    const [quantity, setQuantity] = useState('13');
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPage, setTotalPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const [toastOpcoes, setToastOpcoes] = useState<IToastOpcoes>({ type: "info", visible: false, mensagem: "" })

    useEffect(() => {
        async function checkApi() {
            try {
                const apiService = new ApiService();

                const response = await apiService.get<boolean>("/auth/temAcesso", { params: { tarefa: "Licenças" } })

                if (!response) {
                    navigate("/home");
                }
            } catch (error) {
                navigate("/home");
            }
        }

        checkApi();
    }, []);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        buscarContratos()
    }, [currentPage, quantity, filter])

    const buscarContratos = async () => {
        try {
            setLoading(true)

            const apiService = new ApiService();

            const contratos = await apiService.get<IListaContratosDTO>("/sd48Controller/buscarContratos", {
                params: {
                    currentPage,
                    qtd: quantity,
                    filter: filter
                }
            })

            const pages = Math.ceil(contratos.count / Number(quantity));

            setSd48s(contratos.values)
            setTotalPage(pages)

        } catch (error: any) {
            setToastOpcoes({ type: "error", visible: true, mensagem: `Falha ao buscar licenças! \n ${error.response.data}` })
        } finally {
            setLoading(false)
        }
    }

    const handleEdit = (id: number) => {
        navigate("/contrato/visualizar/" + id)
    };

    const handleFiltrar = (filtro: string, qtd: string) => {
        setFilter(filtro);
        setQuantity(qtd);
    }

    const closeToast = () => {
        setToastOpcoes({ type: "info", visible: false, mensagem: "" })
    }

    const renderMobileView = () => (
        <CardView>
            {sd48s.map(sd48 => (
                <Card key={sd48.sd48id}>
                    <CardField>
                        <label>Data</label>
                        <span>{format(sd48.sd48data, "dd/MM/yyyy")}</span>
                    </CardField>
                    <CardField>
                        <label>Código</label>
                        <span>{sd48.sd48codigo}</span>
                    </CardField>
                    <CardField>
                        <label>Representante</label>
                        <span>{sd48.sd41nome}</span>
                    </CardField>
                    <CardField>
                        <label>Cliente</label>
                        <span>{sd48.sd40na}</span>
                    </CardField>
                    <CardActions>
                        <ActionButton onClick={() => handleEdit(sd48.sd48id!)} disabled={!credencialTemAcesso("prospeccao", "sd031acessa")}>
                            <Edit size={16} />
                        </ActionButton>
                    </CardActions>
                </Card>
            ))}
        </CardView>
    );

    const renderDesktopView = () => (
        <TableContainer>
            <Table>
                <thead>
                    <tr>
                        <Th>#</Th>
                        <Th>Data</Th>
                        <Th>Código</Th>
                        <Th>Representante</Th>
                        <Th>Cliente</Th>
                        <Th>Operações</Th>
                    </tr>
                </thead>
                <tbody>
                    {sd48s.map(sd48 => (
                        <tr key={sd48.sd48id}>
                            <Td>{sd48.sd48id}</Td>
                            <Td>{dayjs(sd48.sd48data).format("DD/MM/YYYY")}</Td>
                            <Td>{sd48.sd48codigo}</Td>
                            <Td>{sd48.sd41nome}</Td>
                            <Td>{sd48.sd40na}</Td>
                            <Td >
                                <ActionButton onClick={() => handleEdit(sd48.sd48id!)} disabled={!credencialTemAcesso("prospecção", "sd031acessa")}>
                                    <Edit size={16} />
                                </ActionButton>
                            </Td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </TableContainer>
    );

    if (loading) {
        return (
            <LoadingPage />
        )
    }

    return (
        <AppLayout>
            <Toast
                isVisible={toastOpcoes.visible}
                message={toastOpcoes.mensagem}
                onClose={closeToast}
                type={toastOpcoes.type}
            />
            <TopActions
                filter={filter}
                quantity={quantity}
                handleAddNew={() => { }}
                filtrar={handleFiltrar}
                disabled
            />
            {isMobile ? renderMobileView() : renderDesktopView()}

            <Pagination
                currentPage={currentPage}
                totalPages={totalPage}
                onPageChange={setCurrentPage}
            />
        </AppLayout>
    );

}